import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import Profile from './AuthProfile';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="dev-236km3fh6zjv1vxd.au.auth0.com"
      clientId="jeJkz21PV90udy8nNnpxG3Tzztk9Hnoa"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://docuquery.aiptf.com/aiquery",
        scope: "openid profile email",
      }}
    >
      <Profile />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
